<script>
    import TheSlider from "@main/packages/TheSlider";
    import GuaranteeItem from "@madrobots/components/GuaranteeItem";
    import { GUARANTEE_BREAKPOINT } from "@madrobots/settings/breakpoints";

    export default {
        name: "GuaranteeList",
        components: {
            TheSlider,
            GuaranteeItem,
        },
        data() {
            return {
                breakpoints: GUARANTEE_BREAKPOINT,
            };
        },
        computed: {
            list() {
                return [
                    {
                        title: "100% подлинность",
                        text: "Мы&nbsp;&mdash; официальный дилер компании XD&nbsp;Design на&nbsp;территории России. Подделки встречаются, но&nbsp;не&nbsp;у&nbsp;нас. Будьте осторожны.",
                        icon: "identity.svg",
                        background: "#27AE4D",
                    },
                    {
                        title: "Возврат без проблем",
                        text: "Вернём деньги или обменяем товар на&nbsp;новый в&nbsp;течение 14&nbsp;дней. Целый год вы&nbsp;можете пользоваться услугами Сервисного Центра.",
                        icon: "return.svg",
                        background: "#FF93B3",
                    },
                    {
                        title: "Быстрая доставка",
                        text: "Экспресс-доставка в&nbsp;день заказа в&nbsp;городах присутствия, от&nbsp;2&nbsp;дней по&nbsp;всей России, широкая сеть постаматов.",
                        icon: "delivery.svg",
                        background: "#F3AF00",
                    },
                    {
                        title: "Удобная оплата",
                        text: "Вы&nbsp;можете оплатить покупку наличными при получении, банковскими картами на&nbsp;сайте и&nbsp;в&nbsp;розничных магазинах Madrobots.",
                        icon: "payment.svg",
                        background: "#51ABFF",
                    },
                    {
                        title: "Компетенция",
                        text: "Madrobots более 7&nbsp;лет на&nbsp;рынке гаджетов, технологий и&nbsp;инноваций. Мы&nbsp;дорожим нашими покупателями и&nbsp;партнерами.",
                        icon: "competence.svg",
                        background: "#8263FF",
                    },
                    {
                        title: "Поддержка 24/7",
                        text: "По&nbsp;любым возникающим вопросами пишите в&nbsp;онлайн-чат в&nbsp;нижнем правом углу экрана или профильным специалистам.",
                        icon: "support.svg",
                        background: "#27A6AE",
                    },
                ];
            },
        },
    };
</script>

<template>
    <div class="guarantee-list">
        <h2 class="guarantee-list__title page-title">Уверенность в покупке</h2>
        <div class="guarantee-list__mobile desktop-hidden">
            <the-slider
                name-slider="guarantee"
                :options="breakpoints"
                :list="list"
                :is-arrow="false"
            >
                <guarantee-item
                    slot="swiper-slide"
                    class="swiper-slide"
                    v-for="(item, index) in list"
                    :key="index"
                    :item="item"
                ></guarantee-item>
            </the-slider>
        </div>

        <div class="guarantee-list__desktop mobile-hidden">
            <div v-for="(item, index) in list" :key="index" class="guarantee-list__item">
                <guarantee-item :item="item"></guarantee-item>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .guarantee-list__title {
        margin-bottom: 30px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            margin-bottom: 60px;
        }
    }

    .guarantee-list__mobile {
        overflow: hidden;
        .swiper-container {
            padding-right: 10px;
        }
        .swiper-wrapper {
            padding: 0 10px;
        }
    }

    .guarantee-list__desktop {
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-wrap: wrap;
            max-width: 1260px;
            margin: 0 auto;
            border-radius: 24px;
            overflow: hidden;
        }
    }

    .guarantee-list__item {
        @include bp($bp-desktop-sm) {
            flex-basis: calc(50% - 10px);
            max-width: calc(50% - 10px);
            margin: 5px;
            border-radius: 24px;
            background-color: var(--primary-background);
        }
        @include bp($bp-desktop-lg) {
            flex-basis: calc(33.3333% - 10px);
            max-width: calc(33.3333% - 10px);
        }
    }
</style>
